import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type ReportsViewReportController from 'webapp/controllers/reports/view/report';

import type Report from 'webapp/models-custom/report';

export default class ReportsViewReportRoute extends Route {
	@service('model-manager/reports') declare mmReportsService: Service.ModelManager.Reports;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		document.body.id = 'datawall';
		document.body.classList.add('live-report');

		const promises: Promise<unknown>[] = [];
		promises.push(this.navigationService.initialRequestsPromise);
		promises.push(this.mmReportsService.requestReports());

		return Promise.all(promises);
	}

	override model(params: { report_id: string }): Report | void {
		let model;

		if (params) {
			model = this.mmReportsService.findModel(params.report_id);
		}

		if (!model) {
			this.navigationService.replaceRoute('reports.index');
			return;
		}

		return model;
	}

	override afterModel(model: Report): Promise<unknown> {
		if (model.id && !this.mmReportsService.isReportDataRequested(model.id)) {
			return this.mmReportsService.requestReportData(model.id);
		}

		return Promise.resolve();
	}

	override setupController(
		controller: ReportsViewReportController,
		model: Report,
		transition: Transition,
	): void {
		super.setupController(controller, model, transition);
		transition.then(() => {
			// when queryparams are set correctly
			controller.activate();
		});
	}

	override resetController(
		controller: ReportsViewReportController,
		isExiting: boolean,
		transition: Transition,
	) {
		super.resetController(controller, isExiting, transition);
		if (isExiting) {
			transition.then(() => {
				// when stopPresentMode has been called
				controller.deactivate();
				document.body.classList.remove('live-report');
			});
		}
	}
}
